import { ReviewSchema } from '@kilat/shared';

import { createRepo } from './_base.js';

/**
 * Reviews repo (operator moderation). Per-outlet reviews at
 * `tenants/{tid}/outlets/{oid}/reviews/{ticketId}`. Rules allow owner/manager/
 * cashier to READ; hiding/un-hiding goes through the `setReviewHidden` callable
 * (owner/manager only), never a direct write.
 */
export function reviewsRepoFor(tenantId: string, outletId: string) {
  return createRepo({
    path: `tenants/${tenantId}/outlets/${outletId}/reviews`,
    schema: ReviewSchema,
    name: `tenants/${tenantId}/outlets/${outletId}/reviews`,
  });
}
